export default {"src":"/_next/static/media/tag.5c45b41e.svg","height":36,"width":35,"blurWidth":0,"blurHeight":0};